import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { dataHooks } from './constants';

export interface MarketingPageLayoutUniDriver extends BaseUniDriver {
  /** Checks whether MarketingPageLayout content exist */
  hasContent(): Promise<boolean>;
  /** Checks whether MarketingPageLayout image exist */
  hasImage(): Promise<boolean>;
  /** Checks whether MarketingPageLayout footer exist */
  hasFooter(): Promise<boolean>;
}

export const marketingPageLayoutDriverFactory = (
  base: UniDriver,
): MarketingPageLayoutUniDriver => {
  return {
    ...baseUniDriverFactory(base),
    hasContent: async () =>
      findByHook(base, dataHooks.contentContainer).exists(),
    hasImage: async () => findByHook(base, dataHooks.imageContainer).exists(),
    hasFooter: async () => findByHook(base, dataHooks.footerContainer).exists(),
  };
};
